import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { PortalPagosComponent } from './pages/portal-pagos/portal-pagos.component';
import { DashboardComponent } from './pages/home/dashboard/dashboard.component';

const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled'
};

const routes: Routes = [
    { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
    {
         path: 'pages', component: AppLayoutComponent,
        children: [
            // { path: 'home/dashboard', loadChildren: () => import('./demo/components/dashboards/dashboards.module').then(m => m.DashboardsModule) },
            { path: 'home/dashboard', component: DashboardComponent },
            { path: 'home/portal', component: PortalPagosComponent },
            { path: 'configuracion', loadChildren: () => import('./pages/configuracion/configuracion.module').then(m => m.ConfiguracionModule)},
            { path: 'seguridad', loadChildren: () => import('./pages/seguridad/seguridad.module').then(m => m.SeguridadModule)},
            { path: 'cobranza', loadChildren: () => import('./pages/cobranza/cobranza.module').then(m => m.CobranzaModule)},
            { path: 'administracion', loadChildren: () => import('./pages/administracion/administracion.module').then(m => m.AdministracionModule)},

        ]
    },
    // { path: 'auth', data: { breadcrumb: 'Auth' }, loadChildren: () => import('./demo/components/auth/auth.module').then(m => m.AuthModule) },
    // { path: 'landing', loadChildren: () => import('./demo/components/landing/landing.module').then(m => m.LandingModule) },
    { path: '', redirectTo: 'auth', pathMatch: 'full' },
    { path: '**', redirectTo: 'notfound' },
    { path: 'notfound', loadChildren: () => import('./demo/components/notfound/notfound.module').then(m => m.NotfoundModule) },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
